/**
 * Color Synchronization for Collection Pages
 * Synchronizes color swatches across all product cards when a color is changed in any product card.
 */
(() => {
  // Prevent infinite loops
  let isSyncing = false;
  
  // Listen for color swatch changes on the collection page
  document.addEventListener('change', function(event) {
    // Check if the change is from a swatch in a product card
    const target = event.target;
    const productCard = target.closest('product-card');
    
    if (!productCard) {
      return;
    }
    
    // Check if it's a color/variant swatch (radio button)
    if (target.type !== 'radio') {
      return;
    }
    
    // Prevent recursive syncing
    if (isSyncing) {
      return;
    }
    
    // Get the selected color value
    const label = target.nextElementSibling;
    const selectedColor = label?.textContent?.trim() || target.value;
    
    if (!selectedColor) {
      return;
    }
    
    isSyncing = true;
    
    // Find all product cards in the collection
    const productCards = document.querySelectorAll('product-card');
    
    productCards.forEach((card) => {
      // Find all radio inputs in this card (color swatches)
      const swatchInputs = card.querySelectorAll('input[type="radio"]');
      
      // Find and select the matching color swatch
      swatchInputs.forEach(input => {
        const inputLabel = input.nextElementSibling;
        const swatchLabel = inputLabel?.textContent?.trim() || input.value;
        
        if (swatchLabel.toLowerCase() === selectedColor.toLowerCase()) {
          if (!input.checked) {
            input.checked = true;
            // Trigger change event to update the card image
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
    
    isSyncing = false;
  }, true); // Use capture phase to catch the event early
})();
